import React from 'react';
import PropTypes from 'prop-types';

const isDev = __DEVBANNER__;
class ContentRollAdsenseClass extends React.Component {
  static propTypes = {
    adClient: PropTypes.string,
    adSlot: PropTypes.string,
  };

  static defaultProps = {
    adClient: 'ca-pub-8183181871645898',
    adSlot: '7650493142',
  };
  render() {
    const { adClient, adSlot, ...other } = this.props;
    const devStyle = {
      width: '100%',
      minHeight: '200px',
      backgroundColor: '#ffb900',
      border: '3px solid #a73c3c',
    };
    if (isDev) {
      return (
        <div style={devStyle}>
          <div>________________slot_________________</div>
          <div>_________ContentRollAdsense__________</div>
          <React.Fragment>{adSlot}</React.Fragment>
          <div>________________STYLE_________________</div>

          <React.Fragment>{JSON.stringify(other.style)}</React.Fragment>
          <div>________________end_block_________________</div>
        </div>
      );
    }
    return (
      <ins {...other} className="adsbygoogle" data-ad-client={adClient} data-ad-slot={adSlot} />
    );
  }
}

export const ContentRollAdsense = ContentRollAdsenseClass;



// WEBPACK FOOTER //
// ./src/shared/modules/googletag/contentRollAdsense.js